import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "crossing-arrows-horiz",
  "use": "crossing-arrows-horiz-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"crossing-arrows-horiz\"><path d=\"M28 21H7.83l3.29-3.29-1.41-1.42L4 22l5.71 5.71 1.41-1.42L7.83 23H28v-2zM4 11h20.17l-3.29 3.29 1.41 1.42L28 10l-5.71-5.71-1.41 1.42L24.17 9H4v2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/crossing-arrows-horiz.svg
// module id = RGaV
// module chunks = 39 44